import { render, staticRenderFns } from "./suggestInputPattern.vue?vue&type=template&id=f4395df8&scoped=true"
import script from "./suggestInputPattern.vue?vue&type=script&lang=js"
export * from "./suggestInputPattern.vue?vue&type=script&lang=js"
import style0 from "./suggestInputPattern.vue?vue&type=style&index=0&id=f4395df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4395df8",
  null
  
)

export default component.exports